import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent, LeModalService, PropertiesQuery} from "common-shared";
import {IWithSpecs, SpecLineModel, SpecModelHandlingService} from "web-shared";
import {MasterOperationModel} from "web-shared";
import {MasterInputInstructionModel, MasterOutputInstructionModel} from "web-shared";
import {
  IPropertyMappingEditorModal,
  PropertyMappingEditorModalComponent
} from "../../../common/property-mapping/property-mapping-editor-modal/property-mapping-editor-modal.component";
import {IntegratedMasterService} from "../services/integrated-master.service";
import {MasterUseInstructionModel} from "web-shared";
import {race} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-ime-spec-lines-view',
  templateUrl: './ime-spec-lines-view.component.html',
  styles: []
})
export class ImeSpecLinesViewComponent extends BaseComponent implements AfterViewInit {
  @Input() specs: SpecLineModel[] = [];
  @Input() readonly = false;
  @Input() context: IWithSpecs;
  @Input() masterOperation: MasterOperationModel;
  @Input() masterInputInstructionModel: MasterInputInstructionModel;
  @Input() masterOutputInstructionModel: MasterOutputInstructionModel;
  @Input() masterUseInstructionModel: MasterUseInstructionModel;
  @Output() changed = new EventEmitter<SpecLineModel[]>();

  constructor(public propertiesQuery: PropertiesQuery, private integratedMasterService: IntegratedMasterService, private modalService: LeModalService, private changeDetector: ChangeDetectorRef, public specModelHandlingService: SpecModelHandlingService) {
    super();
  }

  ngAfterViewInit() {
  }

  editOperationItemProperties(btn: HTMLElement = null) {
    const initialState = this.integratedMasterService.editOperationItemProperties({mo: this.masterOperation, mii: this.masterInputInstructionModel, moi: this.masterOutputInstructionModel, mui: this.masterUseInstructionModel, readonly: this.readonly});
    const modalRef = this.modalService.show(PropertyMappingEditorModalComponent, {initialState, class: 'modal-xl'});
    race(modalRef.onHide$, modalRef.action).pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      if (btn) {
        btn.focus();
      }
      if ((modalRef.content as IPropertyMappingEditorModal).isChanged) {
        this.changed.emit((modalRef.content as IPropertyMappingEditorModal).context.Specs);
      }
      setTimeout(() => {
        this.changeDetector.detectChanges();
      }, 200);
    });
  }

  bySpec(specLineModel: SpecLineModel) {
    return specLineModel.PropertyId;
  }
}
